"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "cacheAction", {
    enumerable: true,
    get: function() {
        return cacheAction;
    }
});
const _clearCache = require("./clearCache.js");
const _config = require("@lage-run/config");
const _pruneCache = require("./pruneCache.js");
const _logger = /*#__PURE__*/ _interop_require_default(require("@lage-run/logger"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function cacheAction(options, command) {
    const cwd = process.cwd();
    const config = await (0, _config.getConfig)(cwd);
    const logger = (0, _logger.default)();
    if (options.clear) {
        return await (0, _clearCache.clearCache)({
            cwd: process.cwd(),
            internalCacheFolder: config.cacheOptions.internalCacheFolder,
            logger,
            concurrency: options.concurrency
        });
    } else if (options.prune) {
        return await (0, _pruneCache.pruneCache)({
            pruneDays: options.prune,
            cwd: process.cwd(),
            internalCacheFolder: config.cacheOptions.internalCacheFolder,
            logger,
            concurrency: options.concurrency
        });
    }
    command.help();
}
